<template>

    <div class="courseEnd-message">
        <!-- <i class="material-icons">check_circle</i>
        <h3>Fin de curso</h3>
    
        <p>Has finalizado el curso. Gracias por participar.</p>

        <button class="btn-downloadCertificate">Descarga tu certificado <i class="material-icons">arrow_forward</i></button> -->


        <!-- volver al inicio del curso button arrow back icon and text-->
         <div class="courseEnd-message__back" @click.stop="router.replace(`/course/${route.params.courseId}`)">
            <i class="material-icons">chevron_left</i>
            <span>{{ $t('module.actions.BACK_TO_COURSE_START') }}</span>
        </div>

        <!-- anterior titulo siguiente 3 divs-->
         <div class="courseEnd-message__title">
            <!-- <button class="courseEnd-message__title--previous"><i class="material-icons">chevron_left</i> Anterior</button> -->
            <h3>Final del curso</h3>
            <!-- <button class="courseEnd-message__title--next">Siguiente <i class="material-icons">chevron_right</i></button> -->
        </div>


        <template v-if="!loadingMinimalInfo && !loadingCourseEndStatus">
            <div v-if="courseEndStatus" class="courseEnd-message__subtitle">
                <i class="material-icons">grading</i>
                <p>Todas las actividades obligatorias completadas</p>
            </div>
    
    
            <div class="courseEnd-message__course-title">
                <h3>{{ mininmalInfo.name }}</h3>
            </div>
    
    
            <div class="courseEnd-message__cover"
                :style="{ backgroundImage: `url(${mininmalInfo.image})` }"></div>


            <div v-if="courseEndStatus" class="courseEnd-message__congrats">
                <i class="material-icons">school</i>
                <p>¡Felicitaciones! Completaste todas las unidades.</p>
            </div>
            <div v-else class="courseEnd-message__pending">
                <i class="material-icons">error</i>
                <p>Aún quedan actividades obligatorias por completar</p>
            </div>
    
        </template>

        <template v-else>
            <div class="courseEnd-message__skeletor">
                <Skeletor height="38" width="40%"/>
                <Skeletor height="200" width="100%"/>
                <Skeletor height="54" width="100%"/>
            </div>
         </template>
         




        
         

        
    </div>



    <!-- loader -->
    <Loader v-if="loadingRelatedCourses" />
    <div class="suggested-courses" v-else-if="relatedCourses.length">
        <h2 class="suggested-courses__title">¿Te gustaría seguir aprendiendo junto a Forge?</h2>
        <div class="courses__pagination">
            <h3 class="courses__title">
                Estos son otros cursos que podrían interesarte
            </h3>
            <div>
                {{ currentPage }} / {{ totalPages }}
                <div class="courses__paginationArrows">
                    <i class="material-icons-outlined" :class="{arrowDisabled: currentPage === 1}" @click="prevPage">arrow_back</i>
                    <i class="material-icons-outlined" :class="{arrowDisabled: currentPage === totalPages}" @click="nextPage">arrow_forward</i>
                </div>
            </div>
        </div>

        <div class="courses">
            <div class="courseCard" v-for="course in paginatedCourses" :key="course.id">
                <div class="courseCard__tutors">
                    <div class="courseCard__tutors__tooltip" style="display: none;">
                        <h5>Facilitadores</h5>
                        <ul>
                            <li v-for="tutor in course.tutors" :key="tutor">{{ tutor }}</li>
                        </ul>
                    </div>
                </div>
                <div class="courseCard__img" :style="{ backgroundImage: `url(${course.image})` }"></div>
                <div class="courseCard__data">
                    <h5>{{ course.name }}</h5>
                </div>
                <p class="courseCard__description">{{ course.description }}</p>
                <div style="display: flex; flex-direction: column; gap: 14px; justify-self: flex-end;">
                    <div style="display: flex; align-items: center; gap: 15px;">
                        <a class="courseCard__button" :href="`/course/${course.id}?t=OD`">Ir al curso<i class="material-icons">arrow_forward</i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <!-- <p>No hay cursos sugeridos en este momento.</p> -->
    </div>
    
    
    <div class="modal__overlay" v-if="canRate && user.role.toLowerCase() === 'learninguser'">
        <div class="modal-rate">
            <i class="material-icons close" @click="canRate = false">close</i>
            <h5>¡Felicitaciones! Finalizaste el curso.</h5>

            <h6>¿Como calificarías el contenido del curso?</h6>
            <div class="stars" v-if="false">
                <template v-if="false">
                    <i class="material-icons" v-for="n in 5" :key="n" @click="rateData.rating = n">star_border</i>
                </template>
                <template v-if="false">
                    <i class="material-icons star-bg" v-for="n in rateData.rating" :key="n" @click="rateData.rating = n">star</i>
                    <i class="material-icons" v-for="n in (5 - rateData.rating)" :key="n" style="cursor:default;" @click="rateData.rating = n">star_border</i>
                </template>
            </div>
            <div class="stars">
                <div>
                    <i class="material-icons" v-for="n in 5" :key="n" @click="rateData.rating = n">star_border</i>
                </div>
                <div class="stars__selected">
                    <i class="material-icons star-bg" v-for="n in rateData.rating" :key="n" @click="rateData.rating = n">star</i>                
                </div>
            </div>
            <div class="stars-reference">
                <span>Malo</span>
                <span>Excelente</span>
            </div>

            <h6>¿Quieres dejar una reseña?</h6>
            <span style="margin: -12px 0 12px 0">(Opcional)</span>
            <textarea v-model="rateData.comment" @keypress="($event) => { if(rateData.comment.length >= 300) $event.preventDefault() }"></textarea>
            <div class="characters-count" :style="{'color': (300 - rateData.comment.length) < 0 ? '#F57055' : ''}">{{ 300  - rateData.comment.length }} caracteres restantes</div>

            <button class="btn-confirm" @click="postRating()" :disabled="!rateData.rating || rateData.comment.length > 300">Enviar<i class="material-icons">arrow_forward</i></button>

            <!-- <div class="step-3" v-if="step == 3">
                <h5>Gracias por tu valoración</h5>
                <h6>Ya puedes descargar tu certificado</h6>
                <button class="btn-confirm" @click="canRate = false;">Descargar certificado<i class="material-icons">arrow_forward</i></button>
            </div> -->

        </div>
    </div>

</template>

<script setup>
import { onMounted, ref, computed, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Loader from '@/components/Loader.vue';
import { Skeletor } from 'vue-skeletor';



const router = useRouter();
const route = useRoute();
const store = useStore();
const courseEndStatus = ref(false);
const loadingCourseEndStatus = ref(false);
const mininmalInfo = ref({});
const loadingMinimalInfo = ref(false);
const canRate = ref(false);
const relatedCourses = ref([]);
const loadingRelatedCourses = ref(false);

const user = computed(() => store.getters.manageUser_user);


const rateData = ref({
    courseId: route.params.courseId,
    rating: null,
    comment: ''
})

// Pagination variables
const currentPage = ref(1);
const pageSize = ref(3);

// Function to update pageSize based on window width
function updatePageSize() {
    if (window.innerWidth <= 700) {
        pageSize.value = 1;
    } else {
        pageSize.value = 3;
    }
}

const totalPages = computed(() => {
    return Math.ceil(relatedCourses.value.length / pageSize.value) || 1;
});

const paginatedCourses = computed(() => {
    const startIndex = (currentPage.value - 1) * pageSize.value;
    return relatedCourses.value.slice(startIndex, startIndex + pageSize.value);
});

function nextPage() {
    if (currentPage.value < totalPages.value) {
        currentPage.value++;
    }
}

function prevPage() {
    if (currentPage.value > 1) {
        currentPage.value--;
    }
}

async function getCourseEndStatus(){
    loadingCourseEndStatus.value = true;
    try {
        let req = await store.dispatch('courses_courseEndStatus', route.params.courseId);
        courseEndStatus.value = req.data.value;
    } catch (error) {
        console.log(error)
    }
    loadingCourseEndStatus.value = false;
}

async function getMinimalInfo(){
    loadingMinimalInfo.value = true;
    try {
        let req = await store.dispatch('courses_getMinimalInfo', route.params.courseId);
        // return req.data;
        mininmalInfo.value = req.data;
    } catch (error) {
        console.log(error)
    }
    loadingMinimalInfo.value = false;
}

async function getRelatedCourses(){
    loadingRelatedCourses.value = true;
    try {
        let req = await store.dispatch('courses_getRelatedCourses', route.params.courseId);
        relatedCourses.value = req.data;
    } catch (error) {
        console.log(error)
    }
    loadingRelatedCourses.value = false;
}

async function checkRating(){
    try {
        let req = await store.dispatch('courses_checkRating', rateData.value.courseId);
        canRate.value = req.data.canRate;
    } catch (error) {
        console.log(error)
    }
}

async function postRating(){
    try {
        await store.dispatch('courses_postRating', rateData.value);
        canRate.value = false;
        store.dispatch('notifications_create', {text: 'Valoración enviada correctamente'});
    } catch (error) {
        console.log(error)
        store.dispatch('notifications_create', {text: 'Error al enviar valoración'});
        canRate.value = false;
    }
}

onMounted(async()=>{
    updatePageSize();
    window.addEventListener('resize', updatePageSize);
    await getCourseEndStatus();
    await getMinimalInfo();
    if(courseEndStatus.value) {
        await checkRating();
    }
    await getRelatedCourses();
})
onUnmounted(() => {
    window.removeEventListener('resize', updatePageSize);
});

</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';
// .courseEnd-message{
//     text-align: center;
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     gap: 16px;

//     & > i {
//         margin-top: 32px;
//         font-size: 48px;
//         color: $green;
//     }

//     h3{
//         text-align: center;
//         color: $green;
//         font-size: 24px;
//         font-weight: 800;
//     }
//     .btn-downloadCertificate{
//         // margin: 16px 0;
//         padding: 8px 16px 8px 29px;
//         @include icon-and-text-container;
//         background-color: $green;
//         color: #fff;
//         font-size: 16px;
//         font-weight: 600;
//         border-radius: 44px;
//     }
// }

.modal-rate{
    position: relative;
    width: 98%;
    max-width: 660px;
    padding: 28px 36px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 10px;
    background: #FFF;
    box-shadow: 5px 5px 35px 0px rgba(217, 217, 217, 0.50);
    @media screen and (max-width: 700px){
        padding: 28px 20px;
    }
    .close{
        position: absolute;
        top: 16px;
        right: 16px;
        cursor: pointer;
    }
    h5{
        font-size: 24px;
        font-weight: 700;
        color: $green;
    }
    h6{
        margin: 42px 0 12px 0;
        font-size: 18px;
        font-weight: 600;
    }
    .stars{
        position: relative;
        >div{
            display: flex;
            align-items: center;
            gap: 16px;
            .material-icons{
                font-size: 46px;
                cursor: pointer;
                color: $green;
            }
        }
        &__selected{
            position: absolute;
            left: 0;
            top: 0;
        }
    }
    .stars-reference{
        display: flex;
        gap: 200px;
        font-size: 14px;
    }
    textarea{
        width: 100%;
        height: 180px;
        padding: 12px;
        border-radius: 4px;
        resize: vertical;
        background: #F6F6F6;
        outline: none;
        border: none;
        &::placeholder{
            padding: 18px 16px;
            font-style: italic;
        }
    }
    .characters-count{
        margin-top: 6px;
        align-self: flex-end;
        font-size: 12px;
        font-weight: 400;
        font-style: italic;
        color: #515151;
    }
    .btn-confirm{
        width: 100%;
        margin-top: 36px;
        padding: 12px 0;
        @include icon-and-text-container;
        justify-content: center;
        background-color: $green;
        color: #fff;
        border-radius: 44px;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.15);
        font-size: 20px;
        .material-icons{
            font-size: 16px;
        }
        &:disabled{
            cursor: default;
        }
    }
}


// HARDCODED COURSES
.courseEnd-message {
    display: flex;
    flex-direction: column;

    .courseEnd-message__skeletor {
        padding-top: 24px;
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .courseEnd-message__back {
        display: flex;
        align-items: center;
        gap: 4px;
        cursor: pointer;
        color: $green;
        font-size: 12px;
        font-weight: 600;
        i {
            font-size: 12px;
        }
    }

    .courseEnd-message__title {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        padding: 32px 0;

        h3 {
            font-size: 22px;
            font-weight: 700;
            line-height: 23px;
            text-align: center;
            color: $green;
        }
        border-bottom: 1px solid #D9D9D9;
    }

    .courseEnd-message__subtitle {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        font-size: 12px;
        font-weight: 600;
        // color: $green;
        margin: 16px 0;
        i {
            font-size: 18px;
        }
    }

    .courseEnd-message__course-title {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 8px;
        margin: 16px 0;

        font-size: 24px;
        font-weight: 700;
        text-align: left;
        color: $green;
    }

    .courseEnd-message__cover {
        width: 100%;
        height: 200px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        margin: 16px 0;
        border-radius: 8px;
    }

    .courseEnd-message__congrats {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 8px;
        padding: 16px;
        // border-radius: 10px;
        background: #BDE4E4;
        color: $green;

        font-size: 16px;
        font-weight: 700;
        text-align: left;


        i {
            font-size: 18px;
        }
    }
    .courseEnd-message__pending {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 8px;
        padding: 16px;
        // border-radius: 10px;
        background: #ffddd7;
        color: #9E5498;

        font-size: 16px;
        font-weight: 700;
        text-align: left;

        i {
            font-size: 18px;
        }
    }

    .courseEnd-message__certificate {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .btn-downloadCertificate {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 12px 24px;
        margin: 16px 0;
        border-radius: 9999px;
        background: transparent;
        color: $green;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        border: 1px solid $green;
    }
    }
    
}

.suggested-courses {
    padding: 48px 0;

    &__title {
        font-size: 24px;
        font-weight: 700;
        color: $green;
        margin-bottom: 16px;
    }
}
.arrowDisabled{
    opacity: .4;
    cursor: default !important;
}
.courses{
    &__pagination{
        display: flex;
        align-items: center;
        justify-content: space-between;
        >div{
            display: flex;
            align-items: center;
            gap: 12px;
            @media screen and (max-width: 700px){
                flex-direction: column;
                align-items: center;
            }
        }
        .material-icons-outlined{
            cursor: pointer;
            width: 24px;
        }
    }
    &__title{
        display: flex;
        align-items: center;
        gap: 12px;
        &--more{
            font-size: 16px;
            display: flex;
            align-items: center;
            color: $green;
            .material-icons-outlined{
                font-size: 18px;
            }
        }
        @media screen and (max-width: 700px){
            flex-direction: column;
            align-items: flex-start;
        }
    }
    &--all{
        flex-wrap: wrap;
    }
    &__paginationArrows{
        display: flex;
        align-items: center;
        gap: 12px;
    }


}
.courseCard{
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
        // min-width: 320px;
        // max-width: 320px;
        min-height: 260px;
        display: flex;
        flex-direction: column;
        padding: 14px;
        border-radius: 10px;
        position: relative;
        width: calc(100% / 3 - 8px);

        @media screen and (max-width: 700px){
            width: 100%;
            margin-bottom: 16px;
        }
        
        &__code{
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            color: #b4b4b4;
            text-overflow: ellipsis;
            overflow: hidden;
            text-wrap: nowrap;
            width: 40%;
        }
        &__pill{
            position: absolute;
            background-color: #fff;
            display: flex;
            align-items: center;
            gap: 6px;
            font-size: 11px;
            font-weight: 600;
            padding: 4px 8px;
            top: 11px;
            right: 16px;
            border-radius: 4px;
            .material-icons{
                font-size: 16px;
            }
            &--true{
                @extend .courseCard__pill;
                color: $green;
                .material-icons{
                    color: $green;
                }
            }
            &--false{
                @extend .courseCard__pill;
                color: $red;
                .material-icons{
                    color: $red;
                }
            }
        }
        .courseCard__data{
            margin: 16px 0 12px 0;
            h5{
                font-weight: 700;   
                font-size: 18px;
                color: $black;
                // height: 50px;
                max-height: 50px;
            }
            span{
                font-weight: 600;
                font-size:12px;
                color: $black;
            }
        }
        
        .courseCard__button{
            background-color: $green;
            color: #fff;
            border-radius: 99999px;
            padding: 12px 28px;
            width: fit-content;
            display: flex;
            align-items: center;
            gap: 8px;
            line-height: 17px;
            &--end{
                @extend .courseCard__button;
                align-self: flex-end;
            }
            &--finished{
                padding: 8px 24px;
                padding-left: 0;
                display: flex;
                align-items: center;
                color: $green;
                gap: 6px;
                font-weight: 600;
                i{
                    font-size: 18px;
                }
            }
            .material-icons{
                font-size: 18px;
            }
        }
        .courseCard__img{
            position: relative;
            border-radius: 10px;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            height: 50%;
            min-height: 110px;
            height: 130px;
            p{
                padding: 8px 16px;
                margin: 4px;
                background-color: #fff;
                color: $green;
                border-radius: 4px;
                width: fit-content;
                font-size: 11px;
                font-weight: 600;
            }
        }

        .courseCard__tutors {
            &__chip {
                display: inline-flex;
                padding: 0 12px;
                align-items: center;
                justify-content: center;
                height: 30px;
                border-radius: 20px;
                gap: 2px;
                font-size: 11px;
                font-weight: 700;
                line-height: 15px;
                letter-spacing: 0em;
                text-align: left;
                background-color: #D5FBFB;
                position: absolute;
                right: 24px;
                top: 24px;
                z-index: 5;
                .material-icons {
                    font-size: 16px;
                }
            }

            &__tooltip {
                position: absolute;
                right: 24px;
                top: 40px;
                background-color: #BDE4E4;
                box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
                border-radius: 10px;
                padding: 12px;
                z-index: 1;
                width: 133px;
                top: 58px;
                border-radius: 10px;
                h5 {
                    font-size: 12px;
                    font-weight: 700;
                    line-height: 15px;
                    letter-spacing: 0em;
                    text-align: left;
                    color: #212121;
                }
                ul {
                    list-style: none;
                    padding: 0;
                    margin: 0;
                    li {
                        font-size: 11px;
                        font-weight: 400;
                        line-height: 18px;
                        letter-spacing: 0em;
                        text-align: left;
                        color: #212121;
                        margin-bottom: 4px;
                    }
                }
            }
        }

        &__description{
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            color: map-get($dark , 600 );
            margin-bottom: 12px;
            height: 36px;
            max-height: 36px;

            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            overflow: hidden;
            white-space: pre-wrap;
            -webkit-box-orient: vertical;
        }
        &__progressBar{
            height: 8px;
            background: linear-gradient(270deg, #009696 0%, #DDDDDD 100%);
            border-radius: 40px;
        }
    }

    .courses{
        width: 100%;
        padding: 12px 6px;
        display: flex;
        gap: 16px;
        overflow: hidden;
        justify-content: flex-start;
        @media screen and (max-width: 700px){
            width: 330px;
            margin: 0 auto;
        }
        &::-webkit-scrollbar-track {
            border-radius: 100px;
            background-color: rgba(0,0,0,.1);
        }
        &::-webkit-scrollbar {
            width: 10px;
            height: 10px;
            background-color: transparent;
            margin: 4px 0;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 100px;
            background: map-get($dark, 400);
            position: absolute;
        }
        &--finished{
            @extend .courses;
            flex-wrap: wrap;
            overflow: visible;
        }
    }
</style>